<template>
  <!--  急救车实况-->
  <div class="index-container">
    <div class="box-mission">
      <div class="mission-title">
        <span class="title">急救任务:</span>
        <span class="clean-mode" @click="cleanMode"> ( 监控模式 ) </span>
      </div>
      <index-swiper :all-lists="ambulanceLists"/>
    </div>
    <div class="history-container">
      <div class="history">
        <div class="mission-title">
          <span class="title">历史记录</span>
        </div>
        <index-history/>
      </div>
      <div class="map-history">
        <div class="mission-title">
          <span class="title">区域定位</span>
        </div>
        <home-map
          v-if="centerMapPoint[0]"
          :center-map-point="centerMapPoint"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IndexSwiper from "@components/Swiper/IndexSwiper";
import IndexHistory from "@views/HomePage/IndexHistory";
import { getPatientsInfo } from "@api/hospitalList";
import screenfull from "screenfull";
import HomeMap from "@components/MapContainer/HomeMap";
import { mapState } from "vuex";

export default {
  name: "Index",
  components: {
    HomeMap,
    IndexSwiper,
    IndexHistory
  },
  data() {
    return {
      // dialogWarning: false,
      centerMapPoint: [], // 医院地址经纬度(经度, 纬度), 必须是数字, 不可字符串
      // idName: "",
      isReRenderMap: true, // watch更新了地图, method就不更新了
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      hospitalInfo: "hospitalInfo"
    }),
  },
  watch: {
    hospitalInfo: {
      handler(val) {
        if (!this.isReRenderMap) return;
        this.getSCoordinate();
      }
    },
  },
  mounted() {
    if (this.hospitalInfo.id) {
      this.getSCoordinate();
      this.isReRenderMap = false;
    }
  },
  methods: {
    // 拿医院地址经纬度
    getSCoordinate() {
      const { longitude, latitude } = this.hospitalInfo;
      this.centerMapPoint = [longitude, latitude];
    },
    // 进入纯净模式
    cleanMode() {
      const currentCar = this.ambulanceLists.find(car => {
        console.log(car);
        return car.statu === "发车中";
      });
      // console.log(currentCar);
      let defaultCar;
      if (currentCar) {
        defaultCar = currentCar.id;
      } else {
        defaultCar = this.ambulanceLists[0]?.id;
      }
      this.$router.push("/cleanMode/" + defaultCar);
    },

  },
};
</script>

<style scoped lang="scss">
.box-mission {
  min-width: 900px;
  background: #fbfbfb;
  height: 320px;
  border-radius: 10px;
  margin-top: 24px;
  padding: 0 30px;
  position: relative;
}

.mission-title {
  padding-top: 24px;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #00476B;
  }
}

.clean-mode {
  user-select: none;
  cursor: pointer;
  font-size: 14px;
  color: #666666;
  margin-left: 16px;
}

.history-container {
  margin-top: 24px;
  display: flex;
}

.history {
  width: 962px;
  height: 404px;
  background: #FBFBFB;
  border-radius: 10px;
  overflow: auto;

  .mission-title {
    padding-left: 30px;
    padding-bottom: 24px;
  }
}

.map-history {
  position: relative;
  width: 626px;
  background: #FBFBFB;
  border-radius: 10px;
  margin-left: 24px;
  padding: 24px 30px;

  .mission-title {
    padding-top: 0;
    padding-bottom: 18px;
  }
}
</style>

